import React from "react";
import CircleIcon from "@mui/icons-material/Circle";

import { Container } from "./styles";
import {
  BoldLg,
  BoldSm,
  HorizontalAlign,
  HorizontalLeftAlign,
  RegMedPri,
} from "../../../Components/CustomStyles";
import Colors from "../../../Constant/Colors";

const index = ({ students, instructor }) => {
  const styles = {
    dot: (isActive) => ({
      fontSize: 12,
      color: isActive ?  Colors.primary:Colors.red,
      margin: 10,
    }),
  };
  return (
    <Container>
      <HorizontalAlign>
        <BoldLg>Instructor</BoldLg>
      </HorizontalAlign>
      <HorizontalLeftAlign>
        {instructor?.active ? (
          <CircleIcon style={styles.dot(true)} />
        ) : (
          <CircleIcon style={styles.dot(false)} />
        )}
        <RegMedPri>{instructor?.first_name}</RegMedPri>
      </HorizontalLeftAlign>
      <HorizontalAlign>
        <BoldSm>Students ({students?.length})</BoldSm>
      </HorizontalAlign>
      {students &&students.length
        ? students.map((each) => (
            <HorizontalLeftAlign>
              {each?.user__active ? (
                <CircleIcon style={styles.dot(true)} />
              ) : (
                <CircleIcon style={styles.dot(false)} />
              )}
              <RegMedPri>{each?.user__first_name}</RegMedPri>
            </HorizontalLeftAlign>
          ))
        : null}
    </Container>
  );
};
export default index;
